import {togglePlayPauseHandler, videoToggleMuteHandler} from "../../global/global";
import VideoPlayIconSvg from "./VideoPlayIconSvg";
import VideoDetailsLink from "./VideoDetailsLink";

export default function DestinationVideo({poster, source, linkLabel, linkPath, autoPlay= false, customStyle= true}) {
    return (
        <div className="video-outer">
            <div className="video position-relative">
                <i
                    onClick={videoToggleMuteHandler}
                    className="position-absolute top-0 left start-0 ri-volume-mute-line px-1 d-inline-block bg-black text-white z-1"
                    role="button" />
                <video
                    style={customStyle && {height: "360px", background: "#000"} || {}}
                    onClick={togglePlayPauseHandler}
                    className="w-100"
                    src={source}
                    poster={poster}
                    autoPlay={autoPlay}
                    muted={true}
                    controls={false}
                    loop={true}
                    playsInline={true}
                    controlsList="nofullscreen"
                />
                <VideoPlayIconSvg/>
            </div>
            <VideoDetailsLink name={linkLabel} linkPath={linkPath}/>
        </div>
    );
}